import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import { throws } from "assert";

interface PropsInterface {
  link: string;
}

interface StateInterface {}

class Default extends React.Component<PropsInterface, StateInterface> {
  public render() {
    return (
      <>
        <div className="modal modal--stand-video">
          <iframe
            src={`https://www.youtube.com/embed/${this.props.link}`}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
